export default "__VITE_ASSET__BgRbkhis__"